import { SURVEY_URL } from "../components/RevenueCalculator/constants";

export const usePaywallsFormSubmit = (action) => {
  return (values) => {
    fetch(`${SURVEY_URL}?id=gallery`, {
      method: "POST",
      body: JSON.stringify({
        data: {
          email: values.email,
          full_name: values.fullName,
        },
      }),
      headers: {
        "Content-Type": "application/json",
      },
    }).catch((err) => {
      console.log(err);
    });
    action();
  };
};
